module.exports = __webpack_public_path__ + "static/media/industria-1.7f9b7f68.jpg";